import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Chatbox from "../layout/common/Chatbox";
import Footer from "../layout/common/Footer";
import Header from "../layout/common/Header";
import NavHeader from "../layout/common/NavHeader";
import SidebarTest from "../layout/common/SidebarTest";
import DeleteBody from "../layout/user/DeleteBody";

const DeletedUsers = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [sortBy, setSortBy] = useState("createdDate");
  const [sortType, setSortType] = useState(true);
  const [showChtBox, setShowChtBox] = useState(false);
  const [userListData, setUserListData] = useState([]);
  const [statusRecord, setStatusRecord] = useState(false);
  const [perPageRecords, setPerPageRecords] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };
  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };

  // server side pagination
  const onChangePageNumberHandler = (e) => {
    setPageNumber(e);
  };

  const sortOnClickHandler = (e) => {
    setSortBy(e);
  };

  const sortTypeOnClickHandler = (e) => {
    setSortType(e);
  };

  const onStatusRecordChangeHandler = (val) => {
    setStatusRecord(!statusRecord);
  };

  const pageChange = (val) => {
    setPerPageRecords(val);
  };

  const searchValueChange = (val) => {
    setSearchValue(val);
  };

  let pageCount = 0;
  if (userListData && userListData.totalUsers && userListData.totalUsers > 0) {
    pageCount = Math.ceil(userListData.totalUsers / perPageRecords);
  }

  useEffect(() => {
    const query = {
      sortby: sortBy,
      sorttype: sortType,
      perpage: perPageRecords,
      currentpage: pageNumber + 1,
      search: searchValue
    };
    (async () => {
      const data = await fetch(process.env.REACT_APP_API_URL +"deleted-users", {
        method: "POST",
        body: JSON.stringify(query),
        headers: {
          "Content-type": "application/json",
        },
      });
      const response = await data.json();
      setUserListData(response);
    })();
  }, [
    pageNumber,
    sortBy,
    statusRecord,
    perPageRecords,
    searchValue,
    sortType
  ]);

  return (
    <React.Fragment>
      <Helmet>
        <title>Deleted Users</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <DeleteBody
        userList={userListData}
        pageNumber={pageNumber}
        onChangePageNumber={onChangePageNumberHandler}
        usersPerPage={perPageRecords}
        pageCount={pageCount}
        onChangeSortClick={sortOnClickHandler}
        onChangeSortType={sortTypeOnClickHandler}
        onStatusRecordChange={onStatusRecordChangeHandler}
        onSearchChang={searchValueChange}
        onPerPageChange={pageChange}
      />
      <Footer />
    </React.Fragment>
  );
}

export default DeletedUsers
